import http from '@/services/http'
import Vue from 'vue'
import { getIndexByKey } from '@/utils'

export default {
  namespaced: true,
  state: {
    event: {
      id: '',
      name: '',
      organization: {
        id: '',
        name: '',
      },
      program_id: null,
      program_config: {},
    },
    fetchInProgress: false,
    saveInProgress: false,

    startups: [],
    startupsFetchInProgress: false,

    users: [],
    usersFetchInProgress: false,
  },
  mutations: {
    startSave(state) {
      state.saveInProgress = true
    },
    stopSave(state) {
      state.saveInProgress = false
    },
    update(state, data) {
      state.event = { ...state.event, ...data }
    },
    startUsersFetch(state) {
      state.usersFetchInProgress = true
    },
    setUsers(state, users) {
      state.users = users
    },
    stopUsersFetch(state) {
      state.usersFetchInProgress = false
    },
    userInvited(state, userId) {
      state.usersFetchInProgress = false
      state.users = state.users.map((user) => {
        if (user.id === userId) {
          const now = new Date()
          user.invited_at = now.toISOString()
        }
        return user
      })
    },
    removeUser(state, email) {
      state.users = state.users.filter((u) => u.email !== email)
    },

    startStartupsFetch(state) {
      state.startupsFetchInProgress = true
    },
    setStartups(state, startups) {
      state.startups = startups
    },
    clearStartups(state, startups) {
      state.startups = []
    },
    setStartupAttrs(state, { startupId, attrs }) {
      state.startups = state.startups.map((s) => {
        if (s.id === startupId) {
          return { ...s, ...attrs }
        } else {
          return s
        }
      })
    },
    stopStartupsFetch(state) {
      state.startupsFetchInProgress = false
    },
    removeStartup(state, startupId) {
      state.startups = state.startups.filter((s) => s.id !== startupId)
    },
    follow(state, { startup }) {
      const idx = getIndexByKey(state.startups, 'id', startup.id)
      Vue.set(state.startups, idx, { ...startup, follows: true })
    },
    unfollow(state, { startup }) {
      const idx = getIndexByKey(state.startups, 'id', startup.id)
      Vue.set(state.startups, idx, { ...startup, follows: false })
    },

    startFetch(state) {
      state.fetchInProgress = true
    },
    setData(state, event) {
      state.event = event
    },
    updateName(state, name) {
      state.event.name = name
    },
    stopFetch(state) {
      state.fetchInProgress = false
    },
  },
  actions: {
    async fetch({ commit, state }, { eventId }) {
      commit('startFetch')
      const response = await http.getAuthed(`/events/${eventId}`)
      commit('setData', response.data)
      commit('stopFetch')
    },
    async updateName({ commit, state }, { name }) {
      commit('updateName', name)
      const eventId = state.event.id
      const url = `/events/${eventId}/update-name`
      await http.postAuthed(url, { name })
    },
    async update({ commit, state }, data) {
      commit('startSave')
      commit('update', data)
      const eventId = state.event.id
      const url = `/events/${eventId}/update`
      try {
        return await http.postAuthed(url, data)
      } finally {
        commit('stopSave')
      }
    },

    async fetchStartups({ commit, state }, { eventId }) {
      commit('startStartupsFetch')
      const response = await http.getAuthed(
        `/events/${eventId}/startup-ratings`,
      )
      commit('setStartups', response.data)
      commit('stopStartupsFetch')
    },
    async addStartups({ commit, state }, { startups }) {
      const eventId = state.event.id
      const url = `/events/${eventId}/add-startups`
      await http.postAuthed(url, { startups })
    },
    async removeStartup({ commit, state }, { startupId }) {
      const startups = [startupId]
      commit('removeStartup', startupId)
      const eventId = state.event.id
      const url = `/events/${eventId}/remove-startups`
      await http.postAuthed(url, { startups })
    },

    async fetchUsers({ commit, state }, { eventId }) {
      commit('startUsersFetch')
      const response = await http.getAuthed(`/events/${eventId}/users`)
      commit('setUsers', response.data)
      commit('stopUsersFetch')
    },
    async addUsers({ commit, state }, { emails }) {
      const eventId = state.event.id
      const url = `/events/${eventId}/add-users`
      await http.postAuthed(url, { emails })
    },
    async removeUser({ commit, state }, { email }) {
      const emails = [email]
      commit('removeUser', email)
      const eventId = state.event.id
      const url = `/events/${eventId}/remove-users`
      await http.postAuthed(url, { emails })
    },
    async sendInvite({ commit, state }, { userId }) {
      commit('userInvited', { userId })
      const eventId = state.event.id
      const url = `/events/${eventId}/invite`
      return http.postAuthed(url, { user_id: userId })
    },

    async visit({ commit, state }, { eventId }) {
      return await http.postAuthed(`/events/${eventId}/visit`)
    },
  },
}
